var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "column is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd",
    },
    [
      _c(
        "b-field",
        { attrs: { label: _vm.label } },
        [
          _c(
            "b-tooltip",
            { attrs: { label: _vm.tooltip, position: "is-bottom" } },
            [
              _c("b-datepicker", {
                attrs: {
                  id: _vm.id,
                  rounded: "",
                  size: "is-small",
                  position: _vm.position,
                  "show-week-number": false,
                  placeholder: "Click to select...",
                  icon: "calendar-today",
                  "date-parser": _vm.parser,
                  "date-formatter": _vm.formatter,
                  "trap-focus": "",
                },
                model: {
                  value: _vm.auxValue,
                  callback: function ($$v) {
                    _vm.auxValue = $$v
                  },
                  expression: "auxValue",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }